const baseUrl = "/jobs"

export const GET_OPTIONS = baseUrl + "/options"

export const GET_EXECUTIONS = baseUrl + "/executions"
